<template>
  <div class="dashboard-form">
    <div class="form-alert" v-show="errors">
      Your credentials doesn't match anything on database
    </div>

    <form @submit.prevent="onSubmit">
      <div class="form-row">
        <input type="email"
        placeholder="Email"
        id="email"
        class="form-input"
        required
        v-model="email">
      </div>

      <div class="form-row">
        <input type="password"
        placeholder="Password"
        id="password"
        class="form-input"
        required
        v-model="password">
      </div>

      <div class="form-row">
        <button type="submit" class="form-button">Login</button>
      </div>
    </form>
  </div>
</template>
<script>
  import {mapActions} from 'vuex'

  export default {

    data() {
      return {
        email: '',
        password: '',
        errors: false
      }
    },

    methods: {
      ...mapActions('auth', ['login']),

      onSubmit() {
        console.log("I'm about to submit");
        const formData = {
          email: this.email,
          password: this.password
        }
        console.log(formData);

        this.login(formData).then(response => {
          this.$router.replace({name: 'home'})
        })
        .catch(error => {
          console.log("An error occurred m8");
          console.log(error)
        });
      },
    }

  }
</script>



// WEBPACK FOOTER //
// src/views/Auth/LoginPage.vue